import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import UpdateCard from './UpdateCard';
import StarRating from './StarRating';
import './Updates.css';

function Updates({ review, updates, loadReviews, toast, isEditable }) {
  const [currentUpdateIndex, setCurrentUpdateIndex] = useState(0);
  const [timelineWidth, setTimelineWidth] = useState(0);
  const [visibleDots, setVisibleDots] = useState(new Set());
  const [revealedDots, setRevealedDots] = useState(new Set());
  const [screenWidth, setScreenWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );
  const [timelineGap, setTimelineGap] = useState(80)

  useEffect(() => {
    if (!review || !updates.length) return;

    const startTime = Date.now();
    const duration = 2000;

    const animate = () => {
      const currentTime = Date.now();
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const currentWidth = progress * 100;
      setTimelineWidth(currentWidth);

      const surgeryTime = new Date(review.surgeryDate).getTime();
      const lastUpdateTime = new Date(updates[updates.length - 1].createdAt).getTime();
      const totalTimeSpan = lastUpdateTime - surgeryTime;

      const newVisibleDots = new Set();
      const newRevealedDots = new Set(revealedDots);

      updates.forEach((update, index) => {
        const updateTime = new Date(update.createdAt).getTime();
        const relativePosition = totalTimeSpan > 0
          ? ((updateTime - surgeryTime) / totalTimeSpan) * 100
          : 0;

        if (currentWidth >= relativePosition) {
          newVisibleDots.add(index);

          if (!revealedDots.has(index)) {
            newRevealedDots.add(index);
            setTimeout(() => {
              setRevealedDots(prev => {
                const updated = new Set(prev);
                updated.delete(index);
                return updated;
              });
            }, 1000);
          }
        }
      });

      setVisibleDots(newVisibleDots);
      setRevealedDots(newRevealedDots);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [review, updates]);

  return (
    <div className="updates-section">
      {Array.isArray(updates) && updates.length > 0 ? (
        <div className="timeline-container">
          <div className="timeline-visualization">
            <div className="timeline-bar" style={{ width: "100%" }}>
              {review.surgeryDate && (
                <div className="timeline-dot first visible">
                  <img width="40" height="40" src="https://img.icons8.com/office/40/scalpel.png" alt="scalpel" />
                  <div className="update-timestamp">
                    {new Date(review.surgeryDate).toLocaleDateString()}
                  </div>
                </div>
              )}
              {updates.map((update, index) => {
                const surgeryTime = new Date(review.surgeryDate).getTime();
                const lastUpdateTime = new Date(updates[updates.length - 1].createdAt).getTime();
                const totalTimeSpan = lastUpdateTime - surgeryTime;
                const updateTime = new Date(update.createdAt).getTime();
                const relativePosition = totalTimeSpan > 0
                  ? ((updateTime - surgeryTime) / totalTimeSpan) * 100
                  : 0;
                let hideTimestamp = false
                let distanceToEnd = (((100 - relativePosition) * screenWidth) / 100)
                if (index < updates.length - 1) {
                  const nextUpdateTime = new Date(updates[index + 1].createdAt).getTime();

                  const nextRelativePosition = totalTimeSpan > 0 ? ((nextUpdateTime - surgeryTime) / totalTimeSpan) * 100 : 0;
                  const relativeDiff = nextRelativePosition - relativePosition;
                  const diff = (relativeDiff * screenWidth) / 100

                  if (diff < timelineGap) {
                    hideTimestamp = true
                  }
                }
                let pushRight = ((60 - distanceToEnd) / 2) - 5
                let styles = {}
                if (pushRight > 0) {
                  styles["left"] = `-${pushRight}px`
                }

                return (

                  <div
                    key={index + 1}
                    className={`timeline-dot ${index === currentUpdateIndex ? 'active' : ''} ${visibleDots.has(index) ? 'visible' : ''} ${relativePosition > 50 ? 'past-half' : 'before-half'} ${index == updates.length - 1 ? 'last' : ''}`}
                    onClick={() => setCurrentUpdateIndex(index)}
                    style={{ left: `${relativePosition}%` }}
                  >
                    <div className={`timeline-dot-content ${revealedDots.has(index) ? 'reveal' : ''}`} style={{ ...styles }}>
                      {Boolean(update.rating) && (
                        <StarRating rating={update.rating} className="timeline-rating" />
                      )}
                      <span className="timeline-date">
                        {format(new Date(update.createdAt), 'MMM d, yyyy')}
                      </span>
                    </div>
                    {!hideTimestamp && (
                      <div className="update-timestamp">
                        {new Date(update.createdAt).toLocaleDateString()}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="timeline-bar" style={{ width: `${timelineWidth}%`, background: "#dee2e6" }}>
            </div>
          </div>
          <div className="updates-timeline">
            <UpdateCard
              update={updates[currentUpdateIndex]}
              setCurrentUpdateIndex={setCurrentUpdateIndex}
              currentUpdateIndex={currentUpdateIndex}
              updatesLength={updates.length}
              isEditable={isEditable}
              toast={toast}
              loadReviews={loadReviews}
              review={review}
            />
          </div>
        </div>
      ) : (
        <p className="no-updates"></p>
      )}

    </div>
  );
}

export default Updates; 